import { render } from "./AdminPanel.vue?vue&type=template&id=4e19f34c&scoped=true&ts=true"
import script from "./AdminPanel.vue?vue&type=script&lang=ts"
export * from "./AdminPanel.vue?vue&type=script&lang=ts"

import "./AdminPanel.vue?vue&type=style&index=0&id=4e19f34c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\miauerka\\web-projects\\mimafi-project\\mimawebapp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e19f34c"]])

export default __exports__